export default __webpack_public_path__ + "static/media/metamask-custom-network-highlight.05c56212.png";